export default "__VITE_ASSET__BJxgq6IF__"